import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	divider: {
		...ColorUtil.getBackgroundAndContrastColor("transparent")
	}
})

export default useStyles
